import React, {Suspense} from "react";
import compose from "lodash/flowRight";
import {Route, Switch, withRouter, Redirect} from "react-router-dom";
import ErrorBoundary from "shared/General/components/ErrorBoundary/ErrorBoundary";
import Spinner from "shared/Experimental/General/components/Spinner/Spinner";
import ProtectedRoutes from "./ProtectedRoutes";
import s from "./AppRoutes.pcss";

const Fallback = () => {
    return (
        <div className={s.container}>
            <Spinner className={s.spinner} />
        </div>
    );
};

const AuthRoutes = React.lazy(() =>
    import(
        /* webpackChunkName: "auth" */ "./modules/Auth/components/AuthRoutes/AuthRoutes"
    ),
);

function AppRoutes(props) {
    // TODO: record product opened here
    if (props.location.pathname === "/") {
        return <Redirect to="/inbox" />;
    }
    return (
        <div className={s.appBody}>
            <Suspense fallback={<Fallback />}>
                <ErrorBoundary>
                    <Switch>
                        <Route
                            path="/auth"
                            render={(p) => (
                                <AuthRoutes
                                    university={props.university}
                                    {...p}
                                />
                            )}
                        />
                        <Route
                            path="/"
                            render={(p) => (
                                <ProtectedRoutes
                                    university={props.university}
                                    {...p}
                                />
                            )}
                        />
                    </Switch>
                </ErrorBoundary>
            </Suspense>
        </div>
    );
}

export default compose(withRouter)(AppRoutes);
